import styled from 'styled-components';
import PropTypes from 'prop-types';
import color from '../../../../config/colors.json';
import uploadIcon from '../../../../img/upload.png';

export const Container = styled.div`
    border: 2px dashed ${color.lightGrey3};
    padding: 11px 14px;
    min-height: 187px;
    &:focus{
        outline: none;
    }

    &.is-invalid{
        border: 2px dashed #FF0040;
    }
`;

export const Label = styled.span`
    color: ${({ labelcolor }) => (labelcolor || color.lightGrey)};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ fontSize }) => fontSize};
    line-height: ${({ lineheight }) => lineheight};
    display: table;
`;

export const UploadIcon = styled.div`
    width: 76px;
    height: 55px;
    background-image: url('${uploadIcon}');
    background-position: center;
    background-size: 99%;
    background-repeat: no-repeat;
`;

PropTypes.Label = {
    labelcolor: PropTypes.string,
    fontSize: PropTypes.string.isRequired,
    lineheight: PropTypes.string.isRequired,
};
